// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutCompanyDescription_wrapper__fsc7R","title":"AboutCompanyDescription_title__UMFjy","description":"AboutCompanyDescription_description__IYeWh"};